import { schema } from 'normalizr'
import { pathOr } from 'ramda'

const solenoid = new schema.Entity('solenoid', {})

const slot = new schema.Entity(
  'slots',
  {
    solenoid,
  },
  {
    idAttribute: 'location',
    processStrategy: (entity) => {
      // solenoid doesn't come back from api if null/undefined
      // so, set that here
      const solenoidId = pathOr(null, ['solenoid', 'functionId'], entity)
      const pending = pathOr(null, ['pending'], entity)
      return {
        ...entity,
        solenoid: solenoidId,
        originalSolenoid: solenoidId,
        pending,
      }
    },
  }
)

export const mod = new schema.Entity('module', {
  slots: [slot],
})

export const ecpModuleSchema = { modules: [mod] }
export const moduleSchema = { module: mod }
export const solenoidSchema = [solenoid]
export const slotSchema = { slots: [slot] }
